// // Function to sort categoriesData based on the most recent post timestamp
// //not using anymore
// export const getSortedCategories = (categoriesData) => {
//   return Object.keys(categoriesData)
//     .map((category) => {
//       const posts = categoriesData[category]; // Get posts based on the category
//       // If there are posts, sort them by timestamp and find the most recent timestamp
//       if (posts && posts.length > 0) {
//         // Sort category's array of posts in descending order by timestamp
//         const sortedPosts = posts.sort(
//           (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
//         );
//         // Get the most recent timestamp
//         const mostRecentTimestamp = new Date(
//           sortedPosts[0].timestamp
//         ).getTime();
//         // Reassign the sorted posts back to the specific category
//         categoriesData[category] = sortedPosts;
//         return { category, mostRecentTimestamp };
//       }
//       return { category, mostRecentTimestamp: 0 }; // Categories with no posts have timestamp 0
//     })
//     .filter((item) => item.mostRecentTimestamp > 0) // Filter out categories with no posts
//     .sort((a, b) => b.mostRecentTimestamp - a.mostRecentTimestamp) // Sort categories by most recent post
//     .map((item) => item.category); // Extract just the category names
// };
// ... existing code ...

//filters and sorts a predefined list of homepage categories based on their posts' timestamps.
export const getSortedHomePageCategories = (categoriesData) => {
  const homePageCategories = [
    'Rentals & Properties',
    'Food & Drinks',
    'Events & Activities',
    'Marketplace',
    'Local Services',
    'Hotels & Unique Stays',
    'Health, Beauty & Wellness',
    'Communities & Social Groups',
    'Announcements',
    'Other',
  ];
  //filters the homePageCategories to include only those categories that currently exist in categoriesData
  return homePageCategories
    .filter((category) => categoriesData[category])
    .map((category) => {
      const homePagePublicPosts = categoriesData[category].filter(
        (post) => post.isPublic === true
      );
      //sorts posts by timestamp
      if (homePagePublicPosts.length > 0) {
        const sortedPosts = homePagePublicPosts.sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        );
        return { category, posts: sortedPosts };
      }
      return null;
    })
    .filter(Boolean);
};


// Refactored function to filter and sort categoriesData by country and optionally by city based on homePageCategories order
export const getSortedCategoriesbyLocation = (categoriesData, selectedCountry = null, selectedCity = null) => {
  // Filter and sort categories using getSortedHomePageCategories logic
  const sortedCategories = getSortedHomePageCategories(categoriesData);
  // Filter posts by the selected country and optionally by selected city
  return sortedCategories
    .map(({ category, posts }) => {
      let filteredPosts = posts;
      // If a country is specified, filter posts by the selected country
      if (selectedCountry) {
        filteredPosts = filteredPosts.filter(post => post.location?.country === selectedCountry);
      }
      // If a city is specified, further filter by city
      if (selectedCity) {
        filteredPosts = filteredPosts.filter(post => post.location?.city === selectedCity);
      }

      if (filteredPosts.length > 0) {
        return { category, posts: filteredPosts };
      }
      return null; // Exclude categories without matching posts
    })
    .filter(Boolean); // Remove null values
};


export const getFeaturedPosts = (categoriesData) => {
  const currentDate = new Date(); // Get the current date
  return Object.keys(categoriesData) // Loop through all categories in categoriesData
    .flatMap((category) => {
      const featuredPosts = categoriesData[category].filter((post) => {
        if (post.featurePost) {
          // Check if featuredUntil exists and if the current date is less than or equal to it
          if (post.featuredUntil) {
            const featuredUntilDate = new Date(post.featuredUntil);
            return currentDate <= featuredUntilDate; // Only include if not expired
          }
          return true; // If no featuredUntil date, consider it featured
        }
        return false; // If featurePost is false, exclude it
      });
      return featuredPosts.length > 0 ? featuredPosts : [];
    });
};

// // Function to sort categoriesData based on the most recent post timestamp and filter by country
// export const getSortedCategoriesbyCountry = (
//   categoriesData,
//   selectedCountry = 'Ecuador'
// ) => {
//   const homePageCategories = [
//     'Rentals & Properties',
//     'Food & Drinks',
//     'Events & Activities',
//     'Marketplace',
//     'Local Services',
//     'Hotels & Unique Stays',
//     'Health, Beauty & Wellness',
//     'Communities & Social Groups',
//     'Announcements',
//     'Other',
//   ];

//   // Create a mapping of category to its index in homePageCategories
//   const categoryOrder = homePageCategories.reduce((acc, category, index) => {
//     acc[category] = index;
//     return acc;
//   }, {});

//   return (
//     Object.keys(categoriesData)
//       .map((category) => {
//         // Filter posts by the selected country
//         const posts = categoriesData[category]?.filter(
//           (post) => post.location?.country === selectedCountry
//           //filter by City too
//         );

//         // If there are posts after filtering, sort them by timestamp and find the most recent timestamp
//         if (posts && posts.length > 0) {
//           // Sort the category's array of posts in descending order by timestamp
//           const sortedPosts = posts.sort(
//             (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
//           );
//           // Get the most recent timestamp
//           const mostRecentTimestamp = new Date(
//             sortedPosts[0].timestamp
//           ).getTime();
//           // Reassign the sorted posts back to the specific category
//           categoriesData[category] = sortedPosts;
//           return { category, mostRecentTimestamp };
//         }
//         return { category, mostRecentTimestamp: 0 }; // Categories with no posts have timestamp 0
//       })
//       .filter((item) => item.mostRecentTimestamp > 0) // Filter out categories with no posts
//       //.sort((a, b) => b.mostRecentTimestamp - a.mostRecentTimestamp) // Sort categories by the most recent post
//       .sort((a, b) => categoryOrder[a.category] - categoryOrder[b.category]) // Sort categories by their original order
//       .map((item) => item.category)
//   ); // Extract just the category names
// };

// Function to sort posts by timestamp
export const sortPostsByTimestamp = (posts) => {
  return posts.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
};

// Function to generate standardized paths for categories
export const generatePath = (category) => {
  return `/${category
    .replace(/&/g, 'and')
    .replace(/-/g, '')
    .replace(/ /g, '')
    .replace(/,/g, '')
    .toLowerCase()}`;
};
